import { render, staticRenderFns } from "./Accessory.vue?vue&type=template&id=f267ddb4&scoped=true"
import script from "./Accessory.vue?vue&type=script&lang=js"
export * from "./Accessory.vue?vue&type=script&lang=js"
import style0 from "./Accessory.vue?vue&type=style&index=0&id=f267ddb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f267ddb4",
  null
  
)

export default component.exports